import { combineReducers } from 'redux';

import {
  REQUEST_PRODUCT_DETAIL,
  SET_RECOMMENDED_FIT
} from 'constants/reduxActions';

import onDemandSizing from './onDemandSizing';

const initialState = {
  recommendedFit: ''
};

export function sizingChooser(state = initialState, action) {
  const { type, recommendedFit } = action;
  switch (type) {
    case SET_RECOMMENDED_FIT:
      return { ...state, recommendedFit };
    case REQUEST_PRODUCT_DETAIL:
      return initialState;
    default:
      return state;
  }
}

export default combineReducers({
  sizingChooser,
  onDemandSizing
});

